import styled, { css } from "styled-components";

export const BannerContainerBox = styled.section`
	position: relative;
	display: flex;
	justify-content: center;
	width: 100%;
	font-size: 0;
	overflow-x: hidden;
	height: fit-content;

	${(props: { width?: string; height?: string }) => {
		if (props.width || props.height) {
			return css`
				width: ${props.width} || "100%";
				height: ${props.height || "auto"};
			`;
		}
		return css`
			width: "100%";
			flex: 1;
		`;
	}}
	& > img {
		width: 100%;
		height: 100%;
		overflow: hidden;
		display: flex;
		justify-content: center;
		align-items: center;
		object-fit: cover;
		object-position: center;
	}
`;
